// Service để điều khiển thiết bị Smart Socket
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

class DeviceService {
  /**
   * Bật/tắt Smart Socket
   * @param {boolean} turnOn - true để bật, false để tắt
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async toggleSmartSocket(turnOn) {
    try {
      const cmd = turnOn ? "ON" : "OFF";
      const response = await fetch(`${API_BASE_URL}/api/devices/led?state=${cmd}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const result = await response.text();
        return {
          success: true,
          message: turnOn ? 'Đã bật ổ cắm thông minh' : 'Đã tắt ổ cắm thông minh',
          data: result
        };
      } else {
        const errorText = await response.text();
        throw new Error(`Server returned ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.error('Error toggling socket:', error);
      return {
        success: false,
        message: `Lỗi: ${error.message}`
      };
    }
  }

  /**
   * Lấy trạng thái Smart Socket
   * @returns {Promise<{isOn: boolean, power: number}>}
   */
  async getSmartSocketStatus() {
    try {
      const [statusResponse, powerResponse] = await Promise.all([
        fetch(`${API_BASE_URL}/api/devices/status`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }),
        fetch(`${API_BASE_URL}/api/devices/power`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
      ]);

      let isOn = false;
      let power = 0.0;

      if (statusResponse.ok) {
        const statusData = await statusResponse.json();
        isOn = statusData.isOn || false;
      }

      if (powerResponse.ok) {
        const powerData = await powerResponse.json();
        power = powerData.power || 0.0;
      }

      return { isOn, power };
    } catch (error) {
      console.error('Error fetching socket status:', error);
      return { isOn: false, power: 0.0 };
    }
  }

  /**
   * Tạo lịch hẹn giờ
   * @param {string} action - "ON" hoặc "OFF"
   * @param {string} scheduledTime - ISO datetime string (ví dụ: "2026-01-03T10:30:00")
   * @param {string} deviceName - Tên thiết bị (mặc định: "Smart Socket")
   * @returns {Promise<{success: boolean, message: string, scheduleId?: number}>}
   */
  async createSchedule(action, scheduledTime, deviceName = "Smart Socket") {
    try {
      const response = await fetch(`${API_BASE_URL}/api/devices/schedule`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: action.toUpperCase(),
          scheduledTime: scheduledTime,
          deviceName: deviceName
        })
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: result.success || true,
          message: result.message || 'Đã tạo lịch hẹn giờ thành công',
          scheduleId: result.scheduleId
        };
      } else {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.message || `Server returned ${response.status}`);
      }
    } catch (error) {
      console.error('Error creating schedule:', error);
      return {
        success: false,
        message: `Lỗi: ${error.message}`
      };
    }
  }

  /**
   * Lấy danh sách schedules
   * @param {number} userId - ID của user (optional)
   * @returns {Promise<{success: boolean, schedules: Array}>}
   */
  async getSchedules(userId = null) {
    try {
      const url = userId 
        ? `${API_BASE_URL}/api/devices/schedules?userId=${userId}`
        : `${API_BASE_URL}/api/devices/schedules`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: true,
          schedules: result.schedules || []
        };
      } else {
        throw new Error(`Server returned ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching schedules:', error);
      return {
        success: false,
        schedules: []
      };
    }
  }
}

// Export singleton instance
export default new DeviceService();




